export default __webpack_public_path__ + "static/media/fireFN10.fce6abee.svg";